import * as P from 'plow-js';
import { createReducer } from 'redux-act';
// feature pivot-table
import * as A from './actions';
//////////////////////////////////////////////////

const initialState = {
  totalCount: 0,
  usedReport: null,
  filterParams: {},
  pivotTableData: null,
  pivotTableType: null,
  availableReports: null,
  defaultSearchCriteria: [],
};

const setInitialState = () => initialState;

const getPivotTableDataSuccess = (state, data = {}) => (
  P.$all(
    P.$set('pivotTableData', data),
    P.$set('totalCount', data.totalCount),
    state,
  )
);

const setReports = (state, data) => (
  P.$set('availableReports', data, state)
);

const setUsedReport = (state, data) => (
  P.$all(
    P.$set('usedReport', data),
    P.$set('pivotTableData', null),
    state,
  )
);

const setPivotReportType = (state, data) => (
  P.$set('pivotReportType', data, state)
);

const setDefaultSearchCriteria = (state, data) => (
  P.$set('defaultSearchCriteria', data, state)
);

export default createReducer({
  [A.setReports]: setReports,
  [A.setUsedReport]: setUsedReport,
  [A.setInitialState]: setInitialState,
  [A.setPivotReportType]: setPivotReportType,
  [A.getPivotTableDataSuccess]: getPivotTableDataSuccess,
  [A.setDefaultSearchCriteria]: setDefaultSearchCriteria,
}, initialState);
